var _path, _path2, _path3, _path4, _path5;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMobileLogo = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3794 3.11157H20.8601L15.0176 10.6778L17.9273 14.2111L26.3794 3.11157Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.98 19.7996L21.2844 27.7811H27.2347L18.0437 16.0059L14.98 19.7996Z",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3485 11.4943L7.45139 3.11157H0.769772L10.1302 14.9431L0 27.7812H7.19736L14.3101 18.9761L17.3814 15.1754L14.3485 11.4943Z",
    fill: ""
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1499 0.482547V0.215088H31.0897V0.482547H30.2815V2.57999H29.9582V0.482547H29.1576H29.1499Z",
    fill: ""
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3301 2.57999V0.215088H31.7304L32.5386 2.07323L33.3469 0.215088H33.7472V2.57999H33.4239V0.806313L32.6464 2.57999H32.4232L31.6534 0.806313V2.57999H31.3301Z",
    fill: ""
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMobileLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mobile-logo.d1a6d53e.svg";
export { ForwardRef as ReactComponent };